// Plain-fetch client for the PUBLIC (no-login) module search endpoints.
// Deliberately NOT part of client.ts (which handles authed sessions).
const BASE = "/api/v1/public/search";

export interface PsHistory {
  shipment_code: string | null;
  customer_name: string | null;
  branch: string | null;
  entered_at: string | null;
  left_at: string | null;
  reason: string | null;
}

export interface PsDetail {
  id: number;
  dev_eui: string;
  model: string | null;
  serial_number: string | null;
  firmware_version: string | null;
  status: string;
  box_number: string | null;
  qr_payload: string | null;
  shipment: { id: number; code: string; status: string } | null;
  customer: { name: string } | null;
  branch: string | null;
  scanned_at: string | null;
  flashed_at: string | null;
  tested_at: string | null;
  labeled_at: string | null;
  shipped_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  passport_url: string;
  history?: PsHistory[];
}

export async function psPing(token: string): Promise<boolean> {
  const r = await fetch(`${BASE}/${encodeURIComponent(token)}/ping`);
  return r.ok;
}

export async function psSearch(token: string, q: string): Promise<PsDetail[]> {
  const r = await fetch(`${BASE}/${encodeURIComponent(token)}/search?q=${encodeURIComponent(q)}`);
  if (!r.ok) throw new Error("search_failed");
  return (await r.json()).items as PsDetail[];
}

export async function psDevice(token: string, id: number): Promise<PsDetail> {
  const r = await fetch(`${BASE}/${encodeURIComponent(token)}/device/${id}`);
  if (!r.ok) throw new Error("device_failed");
  return (await r.json()).device as PsDetail;
}

export async function psUploadXlsx(
  token: string,
  file: File,
): Promise<{ found: PsDetail[]; not_found: { value: string }[] }> {
  const fd = new FormData();
  fd.append("file", file);
  const r = await fetch(`${BASE}/${encodeURIComponent(token)}/xlsx`, { method: "POST", body: fd });
  if (!r.ok) throw new Error("xlsx_failed");
  return await r.json();
}

export async function psExport(
  token: string,
  devEuis: string[],
  notFound: string[],
): Promise<Blob> {
  const r = await fetch(`${BASE}/${encodeURIComponent(token)}/export`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ dev_euis: devEuis, not_found: notFound }),
  });
  if (!r.ok) throw new Error("export_failed");
  return await r.blob();
}
